module.exports = require('./helpers/bundle-url').getBundleURL('bqp0F') + "logo.c51670a8.svg";